@let item = result();

<soft-search-result-item
  icon="fa-solid fa-box"
  [title]="item?.name ?? ''"
  [meta]="meta(item)"
  (click)="openProductDetailView(item)"
>
  @if ($safeNavigationMigration(item?.thumbnail) | media; as thumbnail) {
    @if (item?.thumbnail && thumbnail) {
      <img
        searchResultLeading
        [src]="thumbnail"
        class="max-w-8 max-h-8"
        alt="thumbnail"
      />
    }
  }
</soft-search-result-item>
